import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import CleanKindFields from "~/components/CleanKindFields"
import { updateClean } from "~/apis/cleans"

// Edit an existing clean in place: when, who, and the notes. Used on the
// booking page and the Cleans page so nothing needs a second screen.
export default function CleanEditor({ clean, cleaners, onSaved, onCancel }) {
  const [ form, setForm ] = useState({
    kind: clean.kind,
    window_starts_on: clean.window_starts_on,
    window_ends_on: clean.window_ends_on,
    scheduled_time: clean.scheduled_time || "",
  })
  const [ cleanerId, setCleanerId ] = useState(clean.cleaner_id ? String(clean.cleaner_id) : "")
  const [ instructions, setInstructions ] = useState(clean.instructions || "")
  const [ timingNotes, setTimingNotes ] = useState(clean.timing_notes || "")
  const [ error, setError ] = useState(null)
  const [ busy, setBusy ] = useState(false)

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      const saved = await updateClean(clean.id, {
        kind: form.kind,
        window_starts_on: form.window_starts_on,
        window_ends_on: form.kind === "cleaner_chooses" ? form.window_ends_on : null,
        scheduled_time: form.kind === "scheduled" ? form.scheduled_time || null : null,
        cleaner_id: cleanerId || null,
        instructions,
        timing_notes: timingNotes,
      })
      onSaved(saved)
    } catch (err) {
      setError(err.message)
      setBusy(false)
    }
  }

  return (
    <form onSubmit={submit} className="mt-3 space-y-3 rounded-lg border border-border bg-muted/50 p-3">
      {error && <p className="text-sm text-destructive">{error}</p>}

      <CleanKindFields form={form} onChange={setForm} />

      <div>
        <Label>Cleaner</Label>
        <Select value={cleanerId || "unassigned"} onValueChange={(value) => setCleanerId(value === "unassigned" ? "" : value)}>
          <SelectTrigger className="mt-1 w-full"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="unassigned">{cleaners.length === 0 ? "No cleaner for this property yet" : "Unassigned"}</SelectItem>
            {cleaners.map((c) => <SelectItem key={c.id} value={String(c.id)}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor={`timing-${clean.id}`}>Timing notes (the cleaner sees this)</Label>
        <Input id={`timing-${clean.id}`} value={timingNotes} onChange={(e) => setTimingNotes(e.target.value)} placeholder="e.g. Paula prefers after 12 — confirm by Thursday" className="mt-1" />
      </div>
      <div>
        <Label htmlFor={`instructions-${clean.id}`}>Instructions for the cleaner</Label>
        <Input id={`instructions-${clean.id}`} value={instructions} onChange={(e) => setInstructions(e.target.value)} className="mt-1" />
      </div>

      <div className="flex gap-2">
        <Button type="submit" size="sm" disabled={busy}>{busy ? "Saving…" : "Save changes"}</Button>
        <Button type="button" size="sm" variant="ghost" onClick={onCancel}>Cancel</Button>
      </div>
    </form>
  )
}
